import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import ReactHtmlParser from "react-html-parser";
import SubscriptionPkg from "./SubscriptionPkg";
import SocialShare from "../../component/SocilaShare";

export default function Header(props) {
  const resultdata = props.resultdata;
  const showType = props.showType;
  const globaldata = props?.globaldata;
  let userParams = useParams();
  const symbol = userParams.symbol;
  const [open, setOpen] = React.useState(false);
  const [title, setTitle] = useState("Technical Rank");
  const [showHtmlData, setShowHtmlData] = useState("");
  const handleClose = (res) => {
    setOpen(false);
  };

  const showTechnicalModal = (counter) => {
    if (counter === 1) {
      setShowHtmlData(resultdata?.TechnicalRankData);
      setTitle(" Technical Rank");
    }
    if (counter === 2) {
      setShowHtmlData(resultdata?.shorHtml);
      setTitle(" Short Term Trend");
    }
    if (counter === 3) {
      setShowHtmlData(resultdata?.mediumHtml);
      setTitle(" Medium Term Trend");
    }
    if (counter === 4) {
      setShowHtmlData(resultdata?.longHtml);
      setTitle(" Long Term Trend");
    }
    if (counter === 6) {
      setShowHtmlData(resultdata?.intrinsicHtml);
      setTitle("Intrinsic Value");
    }
    if (counter === 7) {
      setShowHtmlData(resultdata?.intrinsicCounterHtml);
      setTitle("Technical Summary");
    }
    if (counter === 8) {
      setShowHtmlData(resultdata?.DELIV_PER_COUNTER);
      setTitle("Today Del %");
    }
    if (counter === 9) {
      setShowHtmlData(resultdata?.avgfiveDelPer_COUNTER);
      setTitle("5 Day Avg Del %");
    }
    if (counter === 10) {
      setShowHtmlData(resultdata?.avgTenDelPer_COUNTER);
      setTitle("10 Day Avg Del %");
    }
    setOpen(true);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>{ReactHtmlParser(showHtmlData)}</DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <div className="row">
        <div className="col-12 ">
          <div className="comp">
            <strong className="companyindex">
              {resultdata?.excahnge_name} :&nbsp;
            </strong>
            {resultdata?.symbol && (
              <h1>{`${resultdata?.symbol} Share Price`} </h1>
            )}
          </div>
        </div>
        <div className="col-sm-2">
          <div className="row">
            <div className="col-12">
              <label className="sameWidth">SECTOR</label>
              <strong>
                {resultdata?.sectorname ? resultdata?.sectorname : ""}
              </strong>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <label className="sameWidth">LTP :</label>
              <strong>{resultdata?.ltp ? resultdata?.ltp : ""}</strong>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <label className="sameWidth">CHG</label>
              <span className={resultdata?.color ? resultdata?.color : ""}>
                {resultdata?.chg ? resultdata?.chg : ""}(
                {resultdata?.cp ? resultdata?.cp : ""}%)
              </span>
            </div>
          </div>
        </div>

        <div className="col-sm-2">
          <div className="row">
            <div className="col-12">
              <label className="sameWidthThree">Signal </label>
              <strong>
                {resultdata?.signal === "IntradaySell" ||
                resultdata?.signal === "JackpotSell" ||
                resultdata?.signal === "DnTrend" ||
                resultdata?.signal === "LongTSell" ||
                resultdata?.signal === "ShortTSell" ? (
                  <span className="redTxt"> {resultdata?.signal} </span>
                ) : (
                  <span className="greenTxt"> {resultdata?.signal} </span>
                )}
              </strong>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <label className="sameWidthThree">Rec Price</label>
              <strong>
                {resultdata?.rec_price > 0 ? (
                  <span className="greenTxt">{resultdata?.rec_price}</span>
                ) : (
                  "-"
                )}
              </strong>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <label className="sameWidthThree">Signal Time</label>
              <strong>{resultdata?.dtime}</strong>
            </div>
          </div>
        </div>

        <div className="col-sm-2">
          <div className="row">
            <div className="col-12">
              <label className="sameWidthTwo">Today Del % </label>
              <strong>{globaldata.DELIV_PER}</strong>
              {showType > 0 ? (
                <i
                  onClick={(e) => showTechnicalModal(8)}
                  className="fa fa-info-circle  delInfo-circle"
                  title="View More Data"
                ></i>
              ) : (
                <SubscriptionPkg />
              )}
            </div>
            <div className="col-12">
              <label className="sameWidthTwo">5 Day Avg Del % </label>
              <strong>{globaldata.avgfiveDelPer}</strong>
              {showType > 0 ? (
                <i
                  onClick={(e) => showTechnicalModal(9)}
                  className="fa fa-info-circle delInfo-circle "
                  title="View More Data"
                ></i>
              ) : (
                <SubscriptionPkg />
              )}
            </div>
            <div className="col-12">
              <label className="sameWidthTwo">10 Day Avg Del % </label>
              <strong>{globaldata.avgTenDelPer}</strong>
              {showType > 0 ? (
                <i
                  onClick={(e) => showTechnicalModal(10)}
                  className="fa fa-info-circle  delInfo-circle"
                  title="View More Data"
                ></i>
              ) : (
                <SubscriptionPkg />
              )}
            </div>
          </div>
        </div>

        <div className="col-sm-3">
          <div className="row">
            <div className="col-12">
              <label className="sameWidthTwo">Short Term Trend</label>
              <strong>
                {resultdata?.mtwentydma < resultdata?.ltp ? (
                  <span className="greenTxt"> Up </span>
                ) : (
                  <span className="redTxt">Dn</span>
                )}
              </strong>

              {showType > 0 ? (
                <i
                  onClick={(e) => showTechnicalModal(2)}
                  className="fa fa-info-circle infoCircle"
                  title="View More Data"
                ></i>
              ) : (
                <SubscriptionPkg />
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <label className="sameWidthTwo">Medium Term Trend</label>
              <strong>
                {resultdata?.mfiftydma < resultdata?.ltp ? (
                  <span className="greenTxt"> Up </span>
                ) : (
                  <span className="redTxt">Dn</span>
                )}
              </strong>
              {showType > 0 ? (
                <i
                  onClick={(e) => showTechnicalModal(3)}
                  className="fa fa-info-circle infoCircle"
                  title="View More Data"
                ></i>
              ) : (
                <SubscriptionPkg />
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <label className="sameWidthTwo">Long Term Trend</label>
              <strong>
                {resultdata?.mtwohundreddma < resultdata?.ltp ? (
                  <span className="greenTxt"> Up </span>
                ) : (
                  <span className="redTxt">Dn</span>
                )}
              </strong>
              {showType > 0 ? (
                <i
                  onClick={(e) => showTechnicalModal(4)}
                  className="fa fa-info-circle infoCircle"
                  title="View More Data"
                ></i>
              ) : (
                <SubscriptionPkg />
              )}
            </div>
          </div>
        </div>

        <div className="col-sm-3">
          <div className="row">
            <div className="col-12">
              <label className="sameWidthTwo">Technical Rank</label>
              <strong>
                {resultdata?.stocksRanking > 60 ? (
                  <span className="greenTxt">{resultdata?.stocksRanking}</span>
                ) : resultdata?.stocksRanking >= 50 ? (
                  <span className="redTxt">{resultdata?.stocksRanking}</span>
                ) : (
                  <span className="cyanTxt">{resultdata?.stocksRanking}</span>
                )}
              </strong>
              {showType > 0 ? (
                <i
                  onClick={(e) => showTechnicalModal(1)}
                  className="fa fa-info-circle infoCircle"
                  title="View More Data"
                ></i>
              ) : (
                <SubscriptionPkg />
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <label className="sameWidthTwo">Fundamental Rank</label>
              <strong>
                {resultdata?.fundamentalRanking > 60 ? (
                  <span className="greenTxt">
                    {resultdata?.fundamentalRanking}
                  </span>
                ) : resultdata?.fundamentalRanking >= 50 ? (
                  <span className="redTxt">
                    {resultdata?.fundamentalRanking}
                  </span>
                ) : (
                  <span className="cyanTxt">
                    {resultdata?.fundamentalRanking}
                  </span>
                )}
              </strong>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <label className="sameWidthTwo">Valuation Rank</label>
              <strong>
                {resultdata?.fundamentalValue > 60 ? (
                  <span className="greenTxt">
                    {resultdata?.fundamentalValue}
                  </span>
                ) : resultdata?.fundamentalValue >= 50 ? (
                  <span className="redTxt">{resultdata?.fundamentalValue}</span>
                ) : (
                  <span className="cyanTxt">
                    {resultdata?.fundamentalValue}
                  </span>
                )}
              </strong>
              {showType > 0 ? (
                <i
                  onClick={(e) => showTechnicalModal(6)}
                  className="fa fa-info-circle infoCircle"
                  title="View More Data"
                ></i>
              ) : (
                <SubscriptionPkg />
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <label className="sameWidthTwo">Technical Summary </label>
              <i
                onClick={(e) => showTechnicalModal(7)}
                className="fa fa-eye infoCircle"
                title="View More Data"
              ></i>
            </div>
          </div>
        </div>
        <div className="col-sm-12 text-right">
          <SocialShare
            link={`https://www.mntreecapital.com/stocks/${symbol}`}
            description={`ONGC  LTP : ${resultdata?.ltp}  %CHG : ${resultdata?.cp} Period: 1 Week Action: Buy  Rec Price: ${resultdata?.rec_price} Target:  T1:  ${resultdata?.tone} T2: ${resultdata?.ttwo} T3: ${resultdata?.tthree}  Profit/Loss :${resultdata?.prft} SL : ${resultdata?.stoploss}  -Shared via Money Tree Robo Pro`}
          />
        </div>
      </div>
    </>
  );
}
